(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-kit-completo-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btns = document.querySelectorAll('.lp-faq-pergunta');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var resposta = this.nextElementSibling;
        this.setAttribute('aria-expanded', String(!expanded));
        resposta.hidden = expanded;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-kit-completo-produto"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btns = document.querySelectorAll(".lp-accordion-btn");
    btns.forEach(function(btn) {
      btn.addEventListener("click", function() {
        var expanded = this.getAttribute("aria-expanded") === "true";
        var content = this.nextElementSibling;
        this.setAttribute("aria-expanded", String(!expanded));
        content.hidden = expanded;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-kit-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btns = document.querySelectorAll('.lp-faq-pergunta');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var resposta = this.nextElementSibling;
        this.setAttribute('aria-expanded', String(!expanded));
        resposta.hidden = expanded;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-kit-produto"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btn = document.querySelector(".lp-composicao-btn");
    if (btn) {
      btn.addEventListener("click", function() {
        var expanded = this.getAttribute("aria-expanded") === "true";
        var content = this.nextElementSibling;
        this.setAttribute("aria-expanded", String(!expanded));
        content.hidden = expanded;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-kit-widgets"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.getElementById('lp-sticky-bar');
    var variantId = bar ? parseInt(bar.getAttribute('data-variant-id'), 10) : 0;
    var price = bar ? (parseFloat(bar.getAttribute('data-price')) || 189) : 189;

    function fireAddToCart(vid) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'BRL',
            value: price,
            items: [{
              item_id: String(vid),
              item_name: 'Kit ProCare Essencial',
              price: price,
              quantity: 1
            }]
          }
        });
      }
    }

    document.querySelectorAll('.lp-btn-primario, .lp-sticky-btn, .lp-ctar-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var fallback = btn.getAttribute('href') || '/cart';
        var vid = variantId;
        if (!vid) {
          var m = fallback.match(/[?&]id=(\d+)/);
          vid = m ? parseInt(m[1], 10) : 0;
        }
        if (!vid) { window.location.href = fallback; return; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        })
        .then(function() {
          fireAddToCart(vid);
          setTimeout(function() { window.location.href = '/cart'; }, 300);
        })
        .catch(function() { window.location.href = fallback; });
      });
    });

    if (!bar) return;
    function toggle() {
      var show = window.scrollY > 400;
      bar.style.display = show ? 'flex' : 'none';
      bar.setAttribute('aria-hidden', String(!show));
    }
    window.addEventListener('scroll', toggle, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-shih-tzu-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btns = document.querySelectorAll('.lp-faq-pergunta');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var resposta = this.nextElementSibling;
        this.setAttribute('aria-expanded', String(!expanded));
        resposta.hidden = expanded;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-shih-tzu-produto"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btn = document.querySelector(".lp-composicao-btn");
    if (btn) {
      btn.addEventListener("click", function() {
        var expanded = this.getAttribute("aria-expanded") === "true";
        var content = this.nextElementSibling;
        this.setAttribute("aria-expanded", String(!expanded));
        content.hidden = expanded;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parceiros-formulario"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var wrap = document.getElementById('parceiros-form-wrap');
    if (!wrap) return;

    function track(nome, dados) {
      var payload = Object.assign({ event: nome, page: 'parceiros' }, dados || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish(nome, payload);
        }
      } catch (e) {}
    }

    track('view_partner_page');

    document.addEventListener('click', function(e) {
      var cta = e.target.closest('[data-parc-cta]');
      if (cta) track('click_partner_cta', { position: cta.dataset.parcCta });
      if (e.target.closest('[data-parc-whatsapp]')) track('click_partner_whatsapp');
    });

    var whatsappParceiros = wrap.dataset.whatsapp;
    document.querySelectorAll('a[href*="api.whatsapp.com/send"], a[href*="wa.me/"]').forEach(function(link) {
      if (link.hasAttribute('data-parc-whatsapp')) return;
      link.href = whatsappParceiros;
      link.setAttribute('data-parc-whatsapp', '');
    });

    var sticky = document.querySelector('[data-parc-sticky]');
    var hero = document.querySelector('.parc-hero');
    var secaoForm = document.getElementById('formulario');
    if (sticky && hero && secaoForm && 'IntersectionObserver' in window) {
      var visiveis = new Set();
      var observer = new IntersectionObserver(function(entradas) {
        entradas.forEach(function(entrada) {
          if (entrada.isIntersecting) visiveis.add(entrada.target);
          else visiveis.delete(entrada.target);
        });
        var mostrar = visiveis.size === 0;
        sticky.classList.toggle('is-visivel', mostrar);
        document.documentElement.classList.toggle('parc-sticky-on', mostrar);
        document.documentElement.classList.toggle('parc-form-visivel', visiveis.has(secaoForm));
      });
      observer.observe(hero);
      observer.observe(secaoForm);
    }

    if (wrap.querySelector('[data-parc-enviado]')) {
      track('submit_partner_form');
      return;
    }

    var form = document.getElementById('parceiros-form');
    if (!form) return;

    var params = new URLSearchParams(window.location.search);
    var utmGuardado = {};
    try { utmGuardado = JSON.parse(sessionStorage.getItem('parc_utm') || '{}'); } catch (e) {}
    form.querySelectorAll('[data-parc-utm]').forEach(function(campo) {
      var chave = campo.dataset.parcUtm;
      var valor = params.get(chave) || utmGuardado[chave] || '';
      campo.value = valor;
      utmGuardado[chave] = valor;
    });
    try { sessionStorage.setItem('parc_utm', JSON.stringify(utmGuardado)); } catch (e) {}

    var iniciou = false;
    form.addEventListener('focusin', function() {
      if (iniciou) return;
      iniciou = true;
      track('start_partner_form');
    });

    var telefone = form.querySelector('[data-parc-telefone]');
    telefone.addEventListener('input', function() {
      var d = telefone.value.replace(/\D/g, '').slice(0, 11);
      var f = d;
      if (d.length > 2) f = '(' + d.slice(0, 2) + ') ' + d.slice(2);
      if (d.length > 7) f = '(' + d.slice(0, 2) + ') ' + d.slice(2, d.length - 4) + '-' + d.slice(d.length - 4);
      telefone.value = f;
    });

    function mensagemErro(campo) {
      if (campo.type === 'checkbox') {
        return campo.checked ? '' : 'Para enviar, confirme que leu o aviso de privacidade.';
      }
      var valor = campo.value.trim();
      if (campo.required && !valor) return 'Preencha este campo para continuarmos.';
      if (campo === telefone) {
        var digitos = valor.replace(/\D/g, '');
        if (digitos.length < 10 || digitos.length > 11) return 'Confira o número com DDD, por exemplo: (11) 91234-5678.';
      }
      if (campo.type === 'email' && valor && !campo.checkValidity()) return 'Confira o e-mail, por exemplo: nome@empresa.com.br.';
      return '';
    }

    function validar(campo) {
      var msg = mensagemErro(campo);
      var alvo = document.getElementById(campo.id + '-erro');
      if (alvo) alvo.textContent = msg;
      campo.setAttribute('aria-invalid', msg ? 'true' : 'false');
      return !msg;
    }

    var campos = form.querySelectorAll('[required], input[type="email"]');
    campos.forEach(function(campo) {
      campo.addEventListener('blur', function() { validar(campo); });
      campo.addEventListener('change', function() {
        if (campo.getAttribute('aria-invalid') === 'true') validar(campo);
      });
    });

    form.addEventListener('submit', function(e) {
      var primeiroInvalido = null;
      campos.forEach(function(campo) {
        if (!validar(campo) && !primeiroInvalido) primeiroInvalido = campo;
      });
      if (primeiroInvalido) {
        e.preventDefault();
        primeiroInvalido.focus();
        return;
      }

      var email = form.querySelector('#parc-email');
      if (!email.value.trim()) email.value = wrap.dataset.emailPadrao;

      form.querySelector('[data-parc-novidades-valor]').value = form.querySelector('[data-parc-novidades]').checked ? 'Sim' : 'Não';
      form.querySelector('[data-parc-data]').value = new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-kit-widgets"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  /* STICKY BUY BAR — mostra/esconde quando botão nativo sai da tela */
  var mainBtn = document.querySelector('.product-form__submit, [name="add"], .btn-add-to-cart');
  var stickyBar = document.querySelector('.sticky-buy-bar');
  if (mainBtn && stickyBar) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.style.display = entry.isIntersecting ? 'none' : 'flex';
      });
    }, { threshold: 0 });
    obs.observe(mainBtn);
  }

  /* STICKY BAR BOTÃO → adiciona ao carrinho e vai para o checkout */
  var stickyBtn = document.querySelector('.sticky-bar-btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var cartUrl = stickyBtn.getAttribute('data-cart-url');
      if (cartUrl) {
        window.location.href = cartUrl;
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  /* CTAs INTERMEDIÁRIOS → rola até o formulário de compra no topo */
  document.querySelectorAll('.btn-cta-ancora').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      /* Tenta encontrar o formulário nativo do tema */
      var target = document.querySelector(
        'form[action*="/cart/add"], .product-form, .product__form, #product-form'
      );
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  });

  /* FAQ ACCORDION */
  document.querySelectorAll('.faq-pergunta').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.faq-pergunta').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.nextElementSibling.hidden = true;
        b.querySelector('.faq-icone').textContent = '+';
      });
      if (!expanded) {
        btn.setAttribute('aria-expanded', 'true');
        btn.nextElementSibling.hidden = false;
        btn.querySelector('.faq-icone').textContent = '−';
      }
    });
  });

  /* CEP CALCULATOR */
  var cepInput     = document.querySelector('.cep-input');
  var cepBtn       = document.querySelector('.cep-btn');
  var cepResultado = document.querySelector('.cep-resultado');
  if (cepInput) {
    cepInput.addEventListener('input', function () {
      var v = this.value.replace(/\D/g, '');
      if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5, 8);
      this.value = v;
    });
    cepInput.addEventListener('keydown', function (e) { if (e.key === 'Enter' && cepBtn) cepBtn.click(); });
  }
  if (cepBtn && cepInput && cepResultado) {
    cepBtn.addEventListener('click', function () {
      var cep = cepInput.value.replace(/\D/g, '');
      if (cep.length !== 8) { cepResultado.textContent = 'Informe um CEP válido (8 dígitos).'; return; }
      cepResultado.textContent = 'Calculando...';
      fetch('https://viacep.com.br/ws/' + cep + '/json/')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.erro) { cepResultado.textContent = 'CEP não encontrado.'; return; }
          var inicio = addDias(new Date(), 3);
          var fim    = addDias(new Date(), 7);
          var opts   = { day: '2-digit', month: '2-digit' };
          cepResultado.textContent = 'Entrega entre ' + inicio.toLocaleDateString('pt-BR', opts) + ' e ' + fim.toLocaleDateString('pt-BR', opts) + ' para ' + data.localidade + '/' + data.uf;
        })
        .catch(function () { cepResultado.textContent = 'Não foi possível calcular. Tente novamente.'; });
    });
  }
  function addDias(date, days) {
    var d = new Date(date), added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }
    return d;
  }

});

  } catch(e) { console.error(e); }
})();
})();
